import Grid from '@material-ui/core/Grid';
import useTheme from '@material-ui/core/styles/useTheme';
import Typography from '@material-ui/core/Typography';
import { ICriticalityMetrics } from 'interfaces/dashboard';
import React, { memo } from 'react';
import { Bar, BarChart, Cell, ResponsiveContainer, XAxis } from 'recharts';
import Card from '../Component/Card';

interface IProps {
  metrics: ICriticalityMetrics[]
}
function labelPositionFormatter(passedProps: any) {
  const neededProps = {
    height: passedProps.height,
    textAnchor: 'middle',
    width: passedProps.width,
    x: passedProps.x + passedProps.width / 2,
    y: 35
  };

  return (
    <text {...neededProps} style={{ opacity: 0.38, fontWeight: 700 }}>
      {passedProps.value}%
    </text>
  );
}

const Criticality = memo<IProps>((props) => {
  const { metrics } = props;
  const theme = useTheme();
  const colors = ['#8DC640', '#FFD626', '#E24C4B'];

  const total = metrics.reduce((acc, c) => acc + c.value, 0);
  const data = metrics.reverse().map(i => ({ ...i, value: Math.round(i.value > 0 ? ((i.value * 100) / total) : 0) }));

  return (
    <Card bgContent bgcolor='#961132' contentProps={{ padding: 0 }}>
      <Typography
        align='center'
        variant='subtitle1'
        style={{ padding: 0, fontWeight: 'bold' }}
      >
        Criticidade
      </Typography>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <ResponsiveContainer width="100%" height={119}>
            <BarChart height={119} data={data}>
              <XAxis dataKey="criticality" tick={{ fill: theme.palette.text.secondary }} axisLine={false} tickLine={false} />
              <Bar
                dataKey="value"
                fill="#8884d8"
                unit="%"
                label={labelPositionFormatter}
                background={{ fill: '#E6E6E6', radius: 6 }}
                radius={6}
              >
                {metrics.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={colors[index]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Grid>
      </Grid>
    </Card>
  );
});

export default Criticality;